export const getBranchKey = (moduleKey: string, branchIndex: number) => {
  return `${moduleKey}_${branchIndex}`;
};
